// 正規ドメイン(カスタムドメイン)以外で開かれた場合に正規ドメインへ送る。
// B2C のリダイレクトURIは正規ドメインのみ登録しているため、prod の既定 SWA ホスト
// ではログインできない。AADSTS50011 のエラー画面を出さず、初回のMSAL処理(initAuth)
// より前に正規ドメインへリダイレクトする。
//
// 対象は「正規ドメインが前段に立つ prod の既定ホスト(VITE_CANONICAL_SOURCE_HOST)」
// のみ。dev/mvp は別 SWA(別の *.azurestaticapps.net ホスト)であり prod へ寄せては
// いけないため、ホスト名の完全一致で限定する。
const CANONICAL_ORIGIN = import.meta.env.VITE_CANONICAL_ORIGIN ?? '';
const CANONICAL_SOURCE_HOST = import.meta.env.VITE_CANONICAL_SOURCE_HOST ?? '';

/**
 * prod の既定 SWA ホストで開かれていれば正規ドメインへ replace する。
 * 戻り値 true = リダイレクト発火（以降の描画/認証処理を中断すべき）。
 */
export function redirectToCanonicalHost(): boolean {
  if (!CANONICAL_ORIGIN || !CANONICAL_SOURCE_HOST) return false;
  const { origin, hostname, pathname, search, hash } = window.location;
  // 既に正規ドメインなら何もしない（リダイレクトループ防止）
  if (origin === CANONICAL_ORIGIN) return false;
  // prod の既定ホストのみ対象。dev(別SWA: blue-forest 等) や localhost は対象外。
  if (hostname.toLowerCase() !== CANONICAL_SOURCE_HOST.toLowerCase()) return false;
  window.location.replace(`${CANONICAL_ORIGIN}${pathname}${search}${hash}`);
  return true;
}
